;(function () {
  var thisScript = document.currentScript
  var productId = thisScript && thisScript.getAttribute('data-product-id')
  var mapEl =
    productId &&
    document.getElementById('epigraph-variant-sku-map-' + productId)
  if (!mapEl) return

  var variantSkuMap
  try {
    variantSkuMap = JSON.parse(mapEl.textContent)
  } catch (e) {
    return
  }

  function updateTours(epigraphSku) {
    if (!epigraphSku) return
    document.querySelectorAll('epigraph-tour').forEach(function (tour) {
      if (tour.getAttribute('sku') !== epigraphSku) {
        tour.setAttribute('sku', epigraphSku)
      }
    })
  }

  function handleVariantId(variantId) {
    if (!variantId) return
    var sku = variantSkuMap[String(variantId)]
    if (sku) updateTours(sku)
  }

  // Native Shopify variant selectors: <input name="id"> / <select name="id">
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') handleVariantId(e.target.value)
  })

  // Themes that emit a variant:change CustomEvent
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && (e.detail.variant || e.detail)
    if (v && v.id) handleVariantId(v.id)
  })
  document.addEventListener('product:variant:change', function (e) {
    var v = e.detail && (e.detail.variant || e.detail)
    if (v && v.id) handleVariantId(v.id)
  })

  // Themes that update the URL with ?variant=... but don't emit an event
  var lastVariant = new URLSearchParams(window.location.search).get('variant')
  function checkUrl() {
    var v = new URLSearchParams(window.location.search).get('variant')
    if (v && v !== lastVariant) {
      lastVariant = v
      handleVariantId(v)
    }
  }
  window.addEventListener('popstate', checkUrl)
  ;['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m]
    history[m] = function () {
      var ret = orig.apply(this, arguments)
      checkUrl()
      return ret
    }
  })
})()
